export default __webpack_public_path__ + "img/11.1171adfa.jpg";